import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BreakingNews from '../common/BreakingNews';
import StickyAd from '../ads/StickyAd';
import AdBanner from '../ads/AdBanner';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <BreakingNews />
      
      {/* The top-leaderboard ad has been removed */}

      <main className="flex-grow">
        {children}
      </main>

      {/* Bottom leaderboard ad - above footer */}
      <div className="container-custom py-4 flex justify-center">
        <AdBanner 
          id="bottom-leaderboard"
          slot="footer"
          size="leaderboard"
        />
      </div>
      
      <Footer />
      <StickyAd />
    </div>
  );
};

export default Layout;